import styled from 'styled-components';
import {dFlex, dFlexCenter, dFlexBetween, alignStart, dFlexColumn, alignCenter, justifyEnd, justifyStart} from '../../../globalVariables/GlobalFlex';
import {videoContainer} from '../../../component/video/Video.css';
import {getFontSize, getFontWeight, getToken, getSpacing, getPrimitive} from '@tickchak/react-share/app';
import {BGImageCenter, scrollbar} from '../../../globalVariables/GlobalVariables';
import {lightArrow} from '../../../assets/symbols/symbols/Symbols.css';

// Header styles
export const popupHeader = styled.div`
    ${dFlexBetween}
    align-items: center;
    gap: ${getSpacing('space2xl')};
    padding: ${getSpacing('spaceLg')} ${getSpacing('spaceXl')};
    border-bottom: 0.5px solid ${getToken('color.border.subtle')};
    background: ${getToken('color.bg.base')};
`;

export const headerEnd = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyStart}
    gap: ${getSpacing('spaceSm')};
    flex: 1;
    .pop {
        width: 12px;
    }
`;

export const headerActions = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceMd')};
    
    > button:last-child {
        ${dFlexCenter}
        width: 32px;
        height: 32px;
        border-radius: 100px;
        background: ${getToken('color.brand.main')};
        
        svg {
            width: 16px;
            height: 16px;
        }
    }
`;

export const headerTitle = styled.span`
    ${dFlex}
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('bold')};
    color: ${getToken('color.text.default')};
    text-align: center;
`;

// Content area styles
export const videoContentWrapper = styled.div`
    ${dFlexColumn}
    ${alignStart}
    ${scrollbar};
    width: 100%;
    flex: 1;
    min-height: 0;
    padding: ${getSpacing('spaceXl')};
    gap: ${getSpacing('spaceXl')};
    overflow-x: hidden;
    overflow-y: auto;
`;

export const videoTitle = styled.h3`
    margin: 0;
    font-size: ${getFontSize('h3')};
    font-weight: ${getFontWeight('bold')};
    line-height: ${getToken('typography.lineHeight.body')};
    color: ${getToken('color.text.default')};
    text-align: start;
    width: 100%;
`;

export const videoWrapper = styled.div`
    width: 100%;
    border-radius: ${getSpacing('spaceMd')};
    overflow: hidden;
    position: relative;
    aspect-ratio: 16 / 9;
    flex-shrink: 0;
    
    ${videoContainer} {
        width: 100%;
        height: 100%;
    }
`;

// Description text
export const description = styled.div`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('regular')};
    line-height: ${getToken('typography.lineHeight.body')};
    color: ${getToken('color.text.default')};
    text-align: start;
    width: 100%;
    white-space: pre-wrap;
    
    p {
        margin: 0;
        margin-bottom: 0;
    }
    
    ul {
        margin: 0;
        padding-start: ${getSpacing('spaceXl')};
        
        li {
            margin-bottom: 0;
        }
    }
    
    strong {
        font-weight: ${getFontWeight('bold')};
    }
`;

// Footer styles
export const popupFooter = styled.div`
    ${dFlexBetween}
    padding: ${getSpacing('spaceXl')};
    border-top: 1px solid ${getPrimitive('blackAlphas.black05')};
    background: ${getToken('color.bg.base')};
    width: 100%;
    flex-shrink: 0;
`;

export const arrowIcon = styled.span`
    ${dFlexCenter}
    width: 8px;
    height: 12px;
    ${BGImageCenter(lightArrow, 'contain')}
`;
